    // import logo from './logo.svg';
import '../App.css';
import '../lib/animate/animate.min.css';
import '../lib/lightbox/css/lightbox.min.css';
import '../lib/owlcarousel/assets/owl.carousel.min.css';
import '../css/bootstrap.min.css';
import '../css/style.css';



// src/App.js
import React, {useEffect, useState} from 'react';
// import LineChart from './LineChart';
// import CandlestickChart from './candlestick'
// import ConvertAndPrint from "./convertnprint";
import Stockchart from "../components/stockchart_plotly";
import OiTree from "../components/levelchart_plotly";
// import DynamicSubplots from "./components/testplotly";
import Chartgrid from "../components/chartgrid";
import TableDisplay from "../components/tableDisplay";
import DisplayTable from "../components/tableDisplay";
import {useParams} from "react-router-dom";
import StockSearch from "../components/search";
import {fetchMarketMovers, fetchPage} from "../api";
import DataTable from "../components/datatable";
import DynamicStockCharts from "../components/dynamicStockCharts_plotly";
import {fetchNews} from "../api";
import NAV from "./nav";
import TopBar from "./topbar";
import Footer from "./footer";
import Carousel from "./carousel";
import TopMoversHeatmap from "../components/movers";
    import TrendingNewsScroller from "../components/newsscroll";
    import PriceScroller from "../components/pricescroll";
    import IntradayHeatmap from "../components/stocks/intraday_heatmap";
    import IntradayBubbleMap from "../components/stocks/intraday_pv";
    import HighLowVolatilityChart from "../components/stocks/intraday_vol";
    import VolumeSurgeTable from "../components/stocks/intraday_vol_surge";
    import MomentumVsVolChart from "../components/stocks/intraday_vol_mom";



function StockHome() {
  const [movers, setMovers] = useState(null);

  // useEffect(() =>
  //     // Fetch the stock data from an API
  //     {   console.log('STOCK PAGE 1');
  //         fetchMarketMovers()
  //     .then(data => {
  //         const movers = JSON.parse(data)
  //         setMovers(movers);
  //         console.log('Movers',movers);
  //     })
  //     },[])

  return (
      <div>

        {/*<!-- Navbar & Hero Start -->*/}
        <div class="container-fluid position-relative p-0">
            <NAV activetag="stock"/>
            <Carousel activetag="stock"/>

            {/*<!-- Header Start -->*/}
            <div class="container-fluid bg-breadcrumb">
                {/*<div class="container text-center py-5" style={{maxwidth: '500px'}}>*/}
                <div className="container text-center py-2" style={{maxwidth: '500px', maxHeight: '100px'}}>

                    <h4 class="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Stocks</h4>
                    {/*<ol class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">*/}
                    {/*    <li class="breadcrumb-item"><a href="index1.html">Home</a></li>*/}
                    {/*    <li class="breadcrumb-item"><a href="#">Pages</a></li>*/}
                    {/*    <li class="breadcrumb-item active text-primary">Service</li>*/}
                    {/*</ol>*/}
                </div>
            </div>
        <PriceScroller/>
        </div>
        <TrendingNewsScroller/>

            {/*<!-- Header End -->*/}
        {/*<!-- Navbar & Hero End -->*/}

        {/*<!-- Market Snapshot Start -->*/}
        {/*<div class="container-fluid service py-5">*/}
        {/*    <div class="container py-5">*/}
                {/*<div class="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxwidth: '800px'}}>*/}
                {/*    /!*<h4 class="text-primary">Our Services</h4>*!/*/}
                {/*    /!*<h1 class="display-5 mb-4">Market Snapshot </h1>*!/*/}
                {/*    /!*<p class="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.*!/*/}
                {/*    /!*</p>*!/*/}
                {/*</div>*/}
                {/*<div className="row g-4">*/}
                {/*{(movers != null) ?*/}
                {/*    Object.keys(movers).map((key) => (*/}
                {/*                    <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">*/}
                {/*                        <div className="service-item" >*/}
                {/*                        /!*<div height='200px'>*!/*/}
                {/*                            <p className="px-3 py-2">{key.charAt(0).toUpperCase() + key.slice(1)}</p>*/}
                {/*                            <DataTable table='movers' data={JSON.parse(movers[key])}/>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*        ))*/}
                {/*   :""}*/}
                {/*    <TopMoversHeatmap/>*/}
                {/*</div>*/}
            {/*</div>*/}
        {/*</div>*/}
        {/*<!-- Top Stock Movers Start -->*/}
        <div className="container-fluid service py-5">
            <div className="container py-5">
                <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s"
                     style={{maxwidth: '800px'}}>
                    {/*<h4 class="text-primary">Our Services</h4>*/}
                    <h5 className="display-5 mb-4">Top Stock Movers </h5>
                    {/*<p class="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.*/}
                    {/*</p>*/}
                </div>
                <div className="row g-4">

                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
                            <TopMoversHeatmap  symbol={'NIFTY 100'}/>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
                            <TopMoversHeatmap symbol={'sectors'}/>
                        </div>
                    </div>
                    {/*<div className="col-md-12 col-lg-12 wow fadeInUp" data-wow-delay="0.6s">*/}
                </div>
                    {/*</div>*/}
                <div className="row g-4">

                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
                            <IntradayHeatmap/>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
                            <VolumeSurgeTable/>
                        </div>
                    </div>
                    {/*<div className="col-md-12 col-lg-12 wow fadeInUp" data-wow-delay="0.6s">*/}
                </div>
                <div className="row g-4">

                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
                            <IntradayBubbleMap/>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
                            <HighLowVolatilityChart/>
                        </div>
                    </div>

                    {/*<div className="col-md-12 col-lg-12 wow fadeInUp" data-wow-delay="0.6s">*/}
                </div>
                <div className="row g-4">

                    {/*<div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">*/}
                        <div className="service-item" align={'center'}>
                            <MomentumVsVolChart/>
                        </div>
                    {/*</div>*/}
                </div>
            </div>
        </div>
        {/*<!-- Top Stock Movers End -->*/}


        {/*<!-- Tech Analysis Start -->*/}
        <div className="container-fluid service py-5">
            <div className="container py-5">
                <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s"
                     style={{maxwidth: '800px'}}>
                    {/*<h4 class="text-primary">Our Services</h4>*/}
                    <h5 className="display-5 mb-4">Technical Analysis Snapshot </h5>
                    {/*<p class="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.*/}
                    {/*</p>*/}
                </div>
                <div className="row g-4">

                    {/*<div className="col-md-12 col-lg-12 wow fadeInUp" data-wow-delay="0.6s">*/}
                        <div className="service-item">
                        <DisplayTable table='ta' symbol='nifty_50'/>
                        </div>
                    {/*</div>*/}
                    {/*<div className="col-md-12 col-lg-12 wow fadeInUp" data-wow-delay="0.6s">*/}
                </div>
                    {/*</div>*/}
            </div>
        </div>
        {/*<!-- Tech Analysis End -->*/}

        {/*}<!-- Back to Top -->*/}
        <a href="#" class="btn btn-primary btn-lg-square rounded-circle back-to-top"><i class="fa fa-arrow-up"></i></a>


        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.4/jquery.min.js"></script>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0/dist/js/bootstrap.bundle.min.js"></script>
        <script src="../../public/lib/wow/wow.min.js"></script>
        <script src="../../public/lib/easing/easing.min.js"></script>
        <script src="../../public/lib/waypoints/waypoints.min.js"></script>
        <script src="../../public/lib/counterup/counterup.min.js"></script>
        <script src="../../public/lib/lightbox/js/lightbox.min.js"></script>
        <script src="../../public/lib/owlcarousel/owl.carousel.min.js"></script>


        <script src="../../public/js/main.js"></script>
        <script src="../index.js" defer></script>

        {/*</body>*/}
        </div>

  );
}

export default StockHome;

